import React, { useEffect, useState } from 'react';
import { Grid, Modal, Box, Typography, Fab, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { isBrowser, downloadApp, getFromLocalStorage } from 'common';
import { Language } from 'language';
import {
    useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4
};

const DownloadApp = () => {
    const [open, setOpen] = useState(null);
    const handleClose = () => setOpen(false);
    const isRunningInBrowser = isBrowser();
    const location = useLocation();
    const { pathname } = location;
    const user = useSelector(state => state.user.data);
    
    // Check if user is from India (case-insensitive comparison)
    const isIndianUser = user?.country_short_code?.toUpperCase() === 'IN';
    
    // Check if actual geolocation has been determined (not just default)
    const hasLocationBeenDetermined = !!getFromLocalStorage('country');
    
    // Modal is closable if: location not determined yet OR user is from India
    const isClosable = !hasLocationBeenDetermined || isIndianUser;

    const getTodaysDate = () => {
        return new Date().getTime();
    };    

    useEffect(() => {
        const fetchVariableFromLocalStorage = async () => {
            const popup_hidden_till = await new Promise((resolve) => {
                resolve(localStorage.getItem('download_popup'));
            });
    
            if (!pathname.includes('wallet')) {
                // If location hasn't been determined yet OR user is from India, respect the cooldown
                if (isClosable) {
                    const currentTime = new Date().getTime();
                    if (popup_hidden_till) {
                        const storedTime = parseInt(popup_hidden_till, 10);
                        if (currentTime - storedTime < 3600000) {
                            setOpen(false);
                        } else {
                            setOpen(true);
                        }
                    } else {
                        setOpen(true);
                    }
                } else {
                    // For non-Indian users with determined location, always show (persistent)
                    setOpen(true);
                }
            }
        };
    
        fetchVariableFromLocalStorage();
    }, [pathname, isClosable]);

    return (
        <>
            {open && isRunningInBrowser && (
                <Modal 
                    open={open} 
                    onClose={isClosable ? handleClose : undefined}
                    aria-labelledby="modal-modal-title" 
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        {isClosable && (
                            <Fab
                                size="small"
                                color="primary"
                                aria-label="Close"
                                sx={{ position: 'absolute', top: 10, right: 10 }}
                                elevation={3}
                                onClick={() => {
                                    window.localStorage.setItem('download_popup', getTodaysDate());
                                    handleClose();
                                }}
                            >
                                <CloseIcon />
                            </Fab>
                        )}
                        <Typography
                            id="modal-modal-title"
                            variant="h4"
                            component="h2"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            paddingBottom={5}
                        >
                            {Language.generic.download_app}
                        </Typography>
                        <Grid container padding={2} rowSpacing={4.5} columnSpacing={2.75}>
                            {downloadApp(50)}
                            {isClosable && (
                                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        color="error"
                                        aria-label="Close"
                                        elevation={3}
                                        onClick={() => {
                                            window.localStorage.setItem('download_popup', getTodaysDate());
                                            handleClose();
                                        }}
                                    >
                                        {Language.button.continue_on_app}
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                </Modal>
            )}
        </>
    )
}

export default DownloadApp